module.exports = __webpack_public_path__ + "img/3f64566.png";